import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  Snackbar,
  Alert,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import API from "../api";

const ForgotPassword = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const navigate = useNavigate();

  const show = (msg, sev = "error") =>
    setSnack({ open: true, message: msg, severity: sev });

  // Step 1: send code
  const sendCode = async () => {
    if (!email) return show("Enter your email", "warning");
    try {
      await API.post("/forgot-password", { email });
      show("Code sent if that email exists", "success");
      setStep(2);
    } catch (err) {
      show(err.response?.data?.message || "Error sending code");
    }
  };

  // Step 2: verify & reset
  const reset = async () => {
    if (!code || !newPassword)
      return show("Enter code and new password", "warning");
    try {
      await API.post("/forgot-password/confirm", { email, code, newPassword });
      show("Password reset! Redirecting...", "success");
      setTimeout(() => navigate("/login"), 800);
    } catch (err) {
      show(err.response?.data?.message || "Reset failed");
    }
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="#f5f5f5"
    >
      <Paper elevation={4} sx={{ p: 4, width: 360 }}>
        {step === 1 && (
          <>
            <Typography variant="h5" align="center" mb={2}>
              Forgot Password
            </Typography>
            <TextField
              fullWidth
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              sx={{ mb: 3 }}
            />
            <Button fullWidth variant="contained" onClick={sendCode}>
              Send Verification Code
            </Button>
          </>
        )}

        {step === 2 && (
          <>
            <Typography variant="h5" align="center" mb={2}>
              Enter Code & New Password
            </Typography>
            <TextField
              fullWidth
              label="Verification Code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label="New Password"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              sx={{ mb: 3 }}
            />
            <Button fullWidth variant="contained" onClick={reset}>
              Reset Password
            </Button>
          </>
        )}
      </Paper>

      <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        onClose={() => setSnack((s) => ({ ...s, open: false }))}
      >
        <Alert severity={snack.severity}>{snack.message}</Alert>
      </Snackbar>
    </Box>
  );
};

export default ForgotPassword;
